enum MedicalSummaryPanelContext {
    MedicalNote,
    PatientLabTab,
    ResultsTab,
    DocumentsTab,
    PatientDocumentsTab,
    PharmacyOrders
}

export { MedicalSummaryPanelContext };
